import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { LitPage } from '../lit-page';

@customElement('luna-status-chip')
export class LunaStatusChip extends LitPage {
  @property({ attribute: 'label' }) label = '';

  content() {
    return html`
      <div class="luna-status-chip" role="status" aria-live="polite">
        <span class="luna-status-chip__dot" aria-hidden="true"></span>
        <span class="luna-status-chip__label mbw-type-label-chip">${this.label}</span>
      </div>
    `;
  }

  styles() {
    return css`
      .luna-status-chip {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        height: 44px;
        box-sizing: border-box;
        padding: 0 18px;
        border-radius: var(--luna-radius-btn-sm);
        background: var(--luna-surface-statuschip-bg);
        color: var(--mbw-onbar-text);
      }

      .luna-status-chip__dot {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: var(--mbw-onbar-text);
        opacity: 0.85; /* pinned: figma Status Chip */
      }

      .luna-status-chip__label {
        color: inherit;
      }
    `;
  }
}
